import Http from 'services/http2';
import User from 'services/user2';
import Storage from 'services/storage2';
import EnumService from 'services/enum2';
import Util from 'lib/util';
import { WORKFLOW_CONFIG } from 'constants/workflow2';
import Modal from 'services/modal';
import BaseService from 'services/base';
const isEmpty = Util.isEmpty;

const CompanyService = {
  //通用保存接口
  async save(config: any = {}, cb: Function = () => {}) {
    //let successMsg = '操作成功';
    if (typeof config.successMsg === 'string') {
      //successMsg = config.successMsg;
      delete config.successMsg;
    }

    let rs;
    await Http.post('/api/cloudCenter', config).then(response => {
      rs = response;
      if (!response) {
        return;
      } else if (response.success) {
        // this.modal.showTip(successMsg);
        cb(response.data);
      } else {
        alert(response.errorMsg);
      }
    });
    return rs;
  },

  //获取附件列表
  // 1;//合同
  // 2;//资质
  // 3;//报价单单头附件
  // 4;//报价单物料附件
  // 5;//询价单单头附件
  // 6;//询价单物料附件
  // 7;//费用单附件
  // 8;//采购单单头附件
  // 9;//采购单单身附件
  // 10;//企业物料图纸附件
  // 11;//竞价单单头附件
  // 12;//竞价单物料附件
  // 13;//物料图片
  // 14;//出货单身附件
  // 15;//检验单身单身附件
  async getFileList(businessType, businessKey, xkNo, lineNo, companyCode) {
    let list: any[] = [];
    let postbody = {
      businessKey: Array.isArray(businessKey) ? undefined : businessKey,
      businessKeys: Array.isArray(businessKey) ? businessKey : undefined,
      companyCode,
      businessType,
      apiPath: '/archives/compFile/getByBusinessKey'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        list = response.data.map(item => {
          item.fileUrlOld = item.fileUrl;
          item.fileUrl = this.genDownloadUrl(item.fileUrl, true, xkNo, lineNo);
          return item;
        });
      }
    });
    return list;
  },

  //生成下载链接
  genDownloadUrl(fileUrl, isPrivate = true, xkNo, lineNo) {
    let companyCode = Storage.getItem('companyCode'); //默认公司代码
    if (isPrivate) {
      return (
        '/xkyFsCenter/oss/file/download/' +
        xkNo +
        '/' +
        (lineNo || '0') +
        '/' +
        fileUrl +
        '?visitSource=1002&companyCode=' +
        companyCode
      );
    }
    return 'https://xieke-public.oss-cn-shenzhen.aliyuncs.com/' + fileUrl;
  },

  //根据企业平台参数获取详情页面小数位
  async getDecimalPlaceByCodes(
    companyCode: string,
    paramCodes: any[] = [
      'Price_Decimal_Place',
      'Amount_Decimal_Place',
      'Quantity_Decimal_Place'
    ]
  ) {
    if (!companyCode) {
      return {};
    }
    let rs = {},
      oShortCut = {
        Price_Decimal_Place: 'PRICE',
        Amount_Decimal_Place: 'AMOUNT',
        Quantity_Decimal_Place: 'QTY'
      };
    await this.getCompanyParamsByCodes(companyCode, paramCodes, true).then(
      data => {
        paramCodes.forEach(paramCode => {
          if (Array.isArray(data)) {
            let obj = data.filter(val => val.paramCode === paramCode)[0] || {};
            let oParamValue = Util.jsonDecode(obj.paramValue);
            // 缓存了旧数据时，需转换格式
            if (!Util.isObj(oParamValue)) {
              oParamValue = {
                decimalPlaceValue: obj.paramValue,
                decimalPlaceType: 0
              };
            }
            rs[paramCode] = rs[oShortCut[paramCode]] = oParamValue;
          } else {
            rs[paramCode] = rs[oShortCut[paramCode]] = {
              decimalPlaceValue: data[paramCode],
              decimalPlaceType: 0
            };
          }
        });
      }
    );
    return rs;
  },

  /**
   * 获取企业平台参数（无权限限制，可以获取客户的平台参数）
   *
   * @param companyCode {string|array} 企业编码
   * @param codes       参数code数组
   * @param isCache     是否开启缓存
   *
   * @returns 参数数组
   */
  async getCompanyParamsByCodes(companyCode, codes, isCache = false) {
    let arr = [];
    //没传companyCode
    if (
      !companyCode ||
      (Array.isArray(companyCode) && companyCode.length === 0)
    ) {
      return arr;
    }
    let postbody = {
      companyCode: typeof companyCode === 'string' ? companyCode : undefined,
      companyCodes: typeof companyCode === 'string' ? undefined : companyCode,
      paramCodes: codes,
      apiPath: '/archives/compParam/getListByCodes'
    };

    let storageData;
    let cache;
    let key = companyCode + ',' + codes.join(',');

    if (isCache && typeof companyCode === 'string') {
      storageData = Storage.getItem('compParam') || {};
      cache = storageData[key];
    }

    if (cache) {
      return cache;
    } else {
      await Http.post('/api/cloudCenter', postbody).then(response => {
        if (response.success) {
          arr = response.data || [];
          if (isCache && typeof companyCode === 'string') {
            storageData[key] = arr;
            Storage.setItem('compParam', storageData);
          }
        }
      });
      return arr;
    }
  },

  // 检查采购组织是否开启
  async checkOpenOrg(companyCode) {
    if (!companyCode) {
      return;
    }
    let res;
    let postbody = {
      companyCode,
      apiPath: '/archives/sysCtrParam/checkOpenOrg'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        res = response.data;
      }
    });
    return res;
  },

  /**
   * 获取采购组织
   * @param companyCode    企业编码
   * @returns
   */
  async getPurchaseOrgList(companyCode) {
    if (!companyCode) {
      return;
    }
    let postbody = {
      companyCode,
      apiPath: '/archives/compOrg/getErpOrg'
    };
    let arr: any[] = [];
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success && response.data) {
        response.data.forEach(item => {
          arr.push({
            id: item.erpOrgCode,
            text: '(' + item.erpOrgCode + ')' + item.erpOrgName,
            name: item.erpOrgName
          });
        });
      }
    });
    return arr;
  },

  /** 审批流状态流转 begin */

  /**
   * 初始化配置
   *
   * @param workflow {Object} 该对象必须包含 wfmCode。初始化后，会扩展 arrType, data。
   */
  initConfig(workflow) {
    let config = WORKFLOW_CONFIG[workflow.wfmCode];
    if (config) {
      workflow.arrType = config.list
        .filter(item => item.wfTypeCode)
        .map(item => item.wfTypeCode);
      workflow.billXkNoField = config.billXkNoField;
      //初始化complate属性，避免模板报错
      let data = {};
      workflow.arrType.forEach(code => {
        data[code] = { complete: true, canEdit: true };
      });
      workflow.data = data;
    }
    return config;
  },

  /**
   * 初始化审批流
   *
   * @param companyCode {string}
   * @param workflow {Object} 该对象必须包含 wfmCode, billXkNoField, 用于初始化。初始化后，会扩展 arrType, data, isActive属性。
   * @param billXkNo {string} 单号，如果不传，后台不会检查权限
   */
  async initWorkflow(companyCode, workflow, billXkNo) {
    if (Util.isEmpty(companyCode)) {
      return;
    }
    let config = this.initConfig(workflow);

    //列表页不传billXkNo, 只取配置而不判断权限。
    if (!config || workflow.arrType.length === 0 || !billXkNo) {
      return;
    }

    let postbody = {
      companyCode,
      billXkNo,
      wfTypeCodes: workflow.arrType,
      sourceType: 1,
      apiPath: '/workflow/getInfosAndAuth'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data || [];
        if (data.length > 0) {
          data.forEach(item => {
            //当前审批流设置审批关，或启用了OA审批。
            if ((item.useFlag === 1 && item.wfNodeList) || item.useFlag === 2) {
              if (item.wfNodeList) {
                //条件不符合时需要跳过德审批关需要过滤掉
                item.wfNodeList = item.wfNodeList.filter(
                  node => node.skipFlag !== 1
                );
                let length = item.wfNodeList.length;
                item.wfNodeList.forEach((node, i) => {
                  //默认流程状态为初始状态;并记录初始|结束状态编码
                  if (i === 0) {
                    item.wfnXkNo = node.wfnXkNo;
                    item.nodeName = node.nodeName;
                    item.startNode = node.wfnXkNo;
                    item.haveAuthFlag = node.haveAuthFlag;
                  }
                  //结束关编码
                  if (i === length - 1) {
                    item.endNode = node.wfnXkNo;
                  }
                });
              }

              //审批流程重置（撤回）权限码
              if (config && Array.isArray(config.list)) {
                config.list.forEach(configItem => {
                  if (configItem.wfTypeCode === item.wfTypeCode) {
                    item.resetAuthCode = configItem.resetAuthCode;
                  }
                });
              }

              workflow.data[item.wfTypeCode] = item;
              //开启 && 配置了审批关 && 有权限；此时才会有有效数据。
              workflow.isActive = true;
            }
          });
        }
      }
    });
  },

  /**
   * 获取审批流状态
   *
   * @param companyCode {string}
   * @param list {array} 列表项次数组或详情页[this.detail]
   * @param workflow {object} 初始化过后的审批流对象，扩展 arrBtn，arrStatus。
   * @param isDetail {boolean} 是否详情页
   */
  async getWorkflowStatus(companyCode, list, workflow, isDetail = false) {
    let billXkNos: any[] = [];
    list.forEach(item => {
      if (!item.billXkNo) {
        item.billXkNo = item[workflow.billXkNoField];
      }
      billXkNos.push(item.billXkNo);
    });

    let arrName = ['退回', '部分同意', '同意']; //审批状态翻译

    let postbody = {
      companyCode,
      billXkNos,
      apiPath: '/workflowBills/getList'
    };
    let data;
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        data = response.data || [];
      }
    });

    if (!Array.isArray(list) || !Array.isArray(data)) {
      return;
    }

    for (let line of list) {
      //如果是详情页，直接引用workflow；列表页需要克隆后每个项次单独处理。
      line.workflow = isDetail ? workflow : Util.clone(workflow);
      let billStatus =
        line.status !== undefined ? line.status : line.orderStatus;
      line.workflow.arrBtn = []; //先置空流程按钮
      line.workflow.arrStatus = [];

      for (let wfTypeCode of line.workflow.arrType) {
        //审批项
        let item = isDetail
          ? workflow.data[wfTypeCode]
          : line.workflow.data[wfTypeCode];

        //如果当前是平台审批，且审批关没有设置
        if (item.useFlag === 1 && Util.isEmpty(item.wfNodeList)) {
          //编辑按钮是否显示需要依赖此标识
          item.isActive = false;
          continue;
        } else {
          item.isActive = true;
        }

        //从配置信息中复制审批人姓名（当岗位只有一人时，需要显示这个人姓名）
        data.forEach(row => {
          if (Array.isArray(item.wfNodeList)) {
            item.wfNodeList.forEach(node => {
              if (row.wfnXkNo === node.wfnXkNo) {
                if (Array.isArray(row.authList)) {
                  row.authList.forEach(targetAuth => {
                    if (Array.isArray(node.authList)) {
                      node.authList.forEach(sourceAuth => {
                        if (targetAuth.optXkNo === sourceAuth.optXkNo) {
                          targetAuth.checkEmpName = sourceAuth.checkEmpName;
                        }
                      });
                    }
                  });
                }
              }
            });
          }
        });

        //单据状态是审批流的前置状态；
        if (item.preStatus && item.preStatus.includes(billStatus)) {
          let currNode; //当前关
          if (item.wfNodeList) {
            currNode = item.wfNodeList[0]; //默认第一关
          }
          //开启送审时，获取送审状态
          if (item.neededApplyCheckFlag === 1) {
            let applyCheckFlag = await this.getApplyStatus(
              companyCode,
              billXkNos[0],
              item.wfTypeCode
            );
            //已送审状态赋值，用于锁定单据编辑状态
            item.applyCheckFlag = applyCheckFlag;
            if (applyCheckFlag !== 1) {
              //未送审时，当前关设置为待送审
              currNode = {
                nodeName: '待送审',
                applyCheckFlag,
                isApply: true,
                haveAuthFlag: currNode.haveAuthFlag,
                resetAuthCode: currNode.resetAuthCode
              };
              item.nodeName = '待送审';
            } else {
              //已送审时显示第一关
              item.nodeName = currNode.nodeName;
            }
          } else {
            item.nodeName = currNode.nodeName;
          }

          //上一关审批状态
          let oStatus;
          data.forEach(row => {
            if (
              row.billXkNo === line.billXkNo &&
              row.wfTypeCode === wfTypeCode
            ) {
              oStatus = {
                wfTypeCode: row.wfTypeCode,
                wfnXkNo: row.wfnXkNo,
                status: row.status,
                wfName: row.wfTypeName,
                endFlowFlag: row.endFlowFlag,
                authList: row.authList,
                arrStatusName: [row.wfnName + ' ' + arrName[row.status]],
                checkDesc: row.checkDesc
              };
              if (item.useFlag === 2) {
                //OA审批
                oStatus.arrStatusName = [row.wfnName];
              }
            }
          });

          if (oStatus) {
            if (oStatus.endFlowFlag === 1) {
              //最后一关且已同意
              item.complete = true;
            } else {
              item.complete = false;
              item.wfNodeList.forEach((node, i) => {
                if (oStatus.wfnXkNo === node.wfnXkNo) {
                  if (oStatus.status === 1) {
                    //部分同意（会签），停留在当前关
                    currNode = item.wfNodeList[i];
                  } else if (oStatus.status === 2) {
                    //全部同意（会签），显示下一关
                    currNode = item.wfNodeList[i + 1] || item.wfNodeList[i]; //最后一关同意时容错
                  } else if (oStatus.status === 0 && i !== 0) {
                    currNode = item.wfNodeList[i - 1];
                  }
                }
              });
              if (item.useFlag === 1 && currNode) {
                //平台审批显示当前关名称和审批人
                oStatus.arrStatusName.push(currNode.nodeName);
                if (oStatus.status === 2) {
                  //前一关状态：0未审批，1.部分审批，2.已审批。当前关未审批时审批人从配置读取。
                  oStatus.authList = currNode.authList;
                }
                if (currNode.multiCheck === 1) {
                  //会签
                  oStatus.multiCheck = 1;
                }
              }
            }
          } else {
            //未审批过
            if (item.useFlag === 1) {
              //平台审批
              oStatus = {
                wfName: item.wfTypeName,
                authList: item.wfNodeList[0].authList,
                arrStatusName: [null, item.nodeName]
              };
              //待送审时不显示审批人
              if (item.applyCheckFlag !== 1 && currNode.isApply) {
                delete oStatus.authList;
              }
            } else if (item.useFlag === 2) {
              //OA审批
              oStatus = {
                wfName: item.wfTypeName,
                arrStatusName: [null, '待OA审批']
              };
              if (currNode && currNode.isApply) {
                oStatus.arrStatusName = [null, '待送审'];
              }
            }
          }

          if (oStatus) {
            line.workflow.arrStatus.push(oStatus);

            //列表页隐藏操作按钮，以免审批中的单据被改变
            line.workflow.hideBtn = true;

            //当前关是会签，且不是部分同意时, 需要从配置项读取审批人列表
            if (currNode.multiCheck === 1 && oStatus.status !== 1) {
              oStatus.multiCheck = 1;
              oStatus.authList = currNode.authList;
            }
          }

          //判断是否审批中,此时需要隐藏其他业务操作按钮。
          line.workflow.isPending = false;
          //0.审批开启 1.审批流程未结束
          if ([1, 2].includes(item.useFlag) && !item.complete) {
            if (item.neededApplyCheckFlag === 1 && item.applyCheckFlag === 1) {
              //0.送审开启 1.送审中
              line.workflow.isPending = true;
            } else if (
              item.neededApplyCheckFlag !== 1 &&
              item.startNode !== currNode.wfnXkNo
            ) {
              //0.送审未开启 1.审批流不是第一关
              line.workflow.isPending = true;
            }
          }

          //判断是否可以编辑，模板上可以根据此字段锁定编辑状态
          item.canEdit = true; //默认可以编辑
          //流程开启，审批完成或审批中时不得编辑。
          if (
            [1, 2].includes(item.useFlag) &&
            (item.complete || line.workflow.isPending)
          ) {
            item.canEdit = false;
          }

          //设置工作流按钮 0.平台审批 1.有权限；2.审批流程未结束;
          if (
            item.useFlag === 1 &&
            currNode &&
            currNode.haveAuthFlag === 1 &&
            !item.complete
          ) {
            //未来会签升级为岗位中一人审批就算通过时，此处可以由前端来判断，本人或本岗位已签则不再显示按钮
            //todo
            item.wfNodeList.forEach(node => {
              if (node.wfnXkNo === currNode.wfnXkNo) {
                line.workflow.arrBtn.push({
                  ...node,
                  checkStatus: 1,
                  btnName: '同意',
                  wfTypeCode
                });
                line.workflow.arrBtn.push({
                  ...node,
                  checkStatus: 0,
                  btnName: '退回',
                  wfTypeCode
                });
              }
            });
          } else if (item.useFlag === 1 && item.complete) {
            //设置撤回按钮 0.平台审批 1.审批流程结束;
            if (item.resetAuthCode && User.checkAuth(item.resetAuthCode)) {
              line.workflow.arrBtn.push({
                isReset: true,
                checkStatus: 0,
                btnName: '撤回',
                wfTypeCode
              });
            }
          }

          //送审按钮显示逻辑：1.审批开启，2.当前关，3.流程未完成，4.未送审，5.当前关是待送审，6.权限
          if (
            item.useFlag !== 0 &&
            currNode &&
            !item.complete &&
            item.applyCheckFlag !== 1 &&
            currNode.isApply &&
            item.resetAuthCode &&
            User.checkAuth(item.resetAuthCode)
          ) {
            line.workflow.arrBtn.push({
              ...currNode,
              btnName: '送审',
              wfTypeCode
            });
          }
        }
      }
    }

    return workflow;
  },

  /**
   * 获取送审状态
   *
   * @param companyCode {string}
   * @param billXkNo {string}
   * @param item {object} 当前审批关对象
   * @returns applyCheckFlag 送审状态
   */
  async getApplyStatus(companyCode, billXkNo, wfTypeCode) {
    let postbody = {
      companyCode,
      billXkNo,
      wfTypeCode,
      apiPath: '/workflowBills/applyCheck/list'
    };
    let applyCheckFlag;
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        applyCheckFlag = response.data;
      }
    });
    return applyCheckFlag;
  },

  /** 审批流状态流转 end */

  /**
   * 获取自定义字段设置
   *
   * @param companyCode 设置字段公司编码
   * @param isOnlyOpen  是否只获取已开启字段
   * @param billType  单据类型：22.送货单，51.询价, 52对账单, 16.交料通知
   *
   * @returns { list, headCustList, bodyCustList, bodyNormalList, showBodyCol1, showBodyCol2, showBodyCol3, bodyShow }
   */
  async getFieldSetting(companyCode, customerCode, isOnlyOpen, billType = 22) {
    let postbody = {
      billType,
      companyCode,
      customerCode,
      apiPath: '/b2bCompBillFieldDynamicConfig/list'
    };
    let rs;
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        //配置列表，配置页保存用
        let list = response.data || [];
        //单身字段列是否显示
        let showBodyCol1 = false;
        let showBodyCol2 = false;
        let showBodyCol3 = false;
        //单身字段是否显示
        let bodyShow = {};
        if (isOnlyOpen) {
          list = list.filter(item => item.openedFlag === 1);
          let arrField = list.map(item => item.fieldCode);
          //毛重 净重 重量单位
          showBodyCol1 = ['grossWeight', 'netWeight', 'unitWeightName'].some(
            field => arrField.includes(field)
          );
          //包装数 品牌 原产国
          showBodyCol2 = [
            'packingQty',
            'brandName',
            'originalCountryName'
          ].some(field => arrField.includes(field));
          //单身自定义列
          showBodyCol3 = ['extendN01', 'extendN02', 'extendN03'].some(field =>
            arrField.includes(field)
          );
        }
        //自定义字段语言使用的下划线，此处需要转换
        // let lang = Public.lang.replace('-', '_');
        list.forEach(item => {
          item.json = Util.jsonDecode(item.fieldDynamicShowNameJson) || {};
          item.transName = item.json['zh_Hans'];
          if (item.fieldLevel === 1) {
            bodyShow[item.fieldCode] = true;
          }
          item.presetValue = !Util.isEmpty(item.presetValueJson)
            ? Util.jsonDecode(item.presetValueJson)
            : [];
        });
        let headCustList = list.filter(
          item => item.fieldType === 1 && item.fieldLevel === 0
        );
        let bodyCustList = list.filter(
          item => item.fieldType === 1 && item.fieldLevel === 1
        );
        let bodyNormalList = list.filter(
          item => item.fieldType === 0 && item.fieldLevel === 1
        );
        rs = {
          list,
          headCustList,
          bodyCustList,
          bodyNormalList,
          showBodyCol1,
          showBodyCol2,
          showBodyCol3,
          bodyShow
        };
      }
    });
    return rs;
  },

  //获取员工列表
  async getStaffList(
    companyCode,
    inviteStatusList = [2],
    idField = 'xkUniqueCode'
  ) {
    let arr: any[] = [];
    let postbody = {
      companyCode,
      inviteStatusList, //邀约状态 1：邀约中  2：已加入 3：邀约失效  4:离职
      apiPath: '/archives/compEmployee/getListByCompCode'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        response.data.forEach(item => {
          arr.push({
            id: item[idField],
            text: item.employeeName,
            employeeNumber: item.employeeNumber,
            userId: item.userId
          });
        });
      }
    });
    return arr;
  },

  /**
   * 根据权限码获取对应的员工列表
   *
   * @param joinText   是否拼接下拉列表的text
   *
   */
  async getReqEmployeeNameList(
    companyCode: string,
    authCodes: any[] = [],
    idField = 'xkUniqueCode',
    joinText: boolean = false
  ) {
    let rs: any[] = [];
    let postbody = {
      companyCode,
      authCodes,
      apiPath: '/archives/compEmployee/getEmployeesByAuthCodes'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        response.data.forEach(item => {
          let text = item.employeeName;
          if (joinText) {
            //拼接成 员工姓名(工号，部门) 的标准形式
            let arr: any[] = [];
            if (item.employeeNumber) {
              arr.push(item.employeeNumber);
            }
            if (item.erpDepartmentName) {
              arr.push(item.erpDepartmentName);
            }
            if (arr.length) {
              text += ' (' + arr.join(', ') + ')';
            }
          }
          rs.push({
            id: item[idField],
            text: text,
            userId: item.userId,
            employeeNumber: item.employeeNumber,
            employeeName: item.employeeName,
            mobile: item.mobile,
            erpDepartmentName: item.erpDepartmentName
          });
        });
      }
    });
    return rs;
  },

  //获取供应商档案详情
  async getVendorDetail(companyCode: string, vendorXkUniqueCode: string) {
    let data: any = {};
    if (!vendorXkUniqueCode) {
      return data;
    }
    let postbody = {
      companyCode,
      xkUniqueCode: vendorXkUniqueCode,
      apiPath: '/archives/compVendor/getDetailByUniqueCode'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        data = response.data;
        //兼容打印取值（原单头的银行字段，挪入列表）
        if (Array.isArray(data.bankList)) {
          data.bankList.some((item, i) => {
            if (i === 0 || item.isDefault === 1) {
              data.openAccountBankName = item.openAccountBankName;
              data.bankCardNo = item.bankCardNo;
            }
            return item.isDefault === 1;
          });
        }
      } else {
        alert(response.errorMsg);
      }
    });
    return data;
  },

  //获取客户档案详情
  async getCustomerDetail(
    companyCode: string,
    customerXkUniqueCode: string,
    isCache: boolean = false
  ) {
    let data: any = {};
    let cacheKey = 'compCustomergetDetailByUniqueCode';
    let postbody = {
      companyCode,
      xkUniqueCode: customerXkUniqueCode,
      apiPath: '/archives/compCustomer/getDetailByUniqueCode'
    };

    let storageData;
    let cache;
    let key = companyCode + ',' + customerXkUniqueCode;

    if (isCache) {
      storageData = Storage.getItem(cacheKey) || {};
      cache = storageData[key];
    }

    if (cache) {
      return cache;
    } else {
      await Http.post('/api/cloudCenter', postbody).then(response => {
        if (response.success) {
          data = response.data;
          EnumService.getValue('B02_Invite_Status', data.inviteStatus).then(
            value => {
              data.inviteStatusName = value;
            }
          );
          EnumService.getValue('B02_Vendor_Status', data.customerStatus).then(
            value => {
              data.CustomerStatusName = value;
            }
          );
        }
      });

      if (isCache) {
        storageData[key] = data;
        Storage.setItem(cacheKey, storageData);
      }

      return data;
    }
  },

  //获取送货信息
  async getDeliveryInfo(item) {
    let paramValue;
    let receiveAreaType;
    let storehouseList;
    let errormsg;
    //供应商是否按仓库送货
    await this.getCompanyParamsByCodes(item.customerCode, [
      'Vendor_delivery_by_storehouse'
    ]).then(rs => {
      if (rs.length > 0 && rs[0].paramValue === '1') {
        paramValue = rs[0].paramValue;
        receiveAreaType = Number(rs[0].paramFilter);
      }
    });
    if (paramValue === '1') {
      let postbody = {
        companyCode: User.getDefaultCompanyCode(),
        customerCode: item.customerCode,
        poXkNo: item?.poXkNo,
        poXkNos: item.poXkNos,
        apiPath: '/customerPurchase/listReceiveAreaByPo'
      };
      await Http.post('/api/cloudCenter', postbody).then(response => {
        if (response.success) {
          storehouseList = response.data.receiveAreaList.map(items => {
            return { id: items.receiveAreaCode, text: items.receiveAreaName };
          });
        } else {
          errormsg = response.errorMsg;
        }
      });
    }

    let data = {
      storehouseList: storehouseList,
      paramValue: paramValue,
      receiveAreaType: receiveAreaType,
      errormsg: errormsg
    };
    return data;
  },

  /**
   * 检查是否开启利润中心（本地缓存）
   *
   * @param companyCode 企业编码|客户编码
   * @param isCache     是否开本地缓存
   *
   * @returns {boolean} 是否开启
   */
  async checkOpenProfit(companyCode: string, isCache: boolean = true) {
    let res: boolean = false;
    let storageData;
    let cache;
    if (isCache && companyCode) {
      storageData = Storage.getItem('openProfit') || {};
      cache = storageData[companyCode];
    }
    if (cache) {
      return cache;
    }
    let postbody = {
      companyCode,
      apiPath: '/archives/sysCtrParam/checkOpenProfit'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        res = response.data;
        if (isCache) {
          storageData[companyCode] = res;
          Storage.setItem('openProfit', storageData);
        }
      }
    });
    return res;
  },

  //获取利润中心列表（基础资料）
  async getProfitCenterList(companyCode) {
    let postbody = {
      companyCode,
      apiPath: '/archives/profit/queryListPageResp'
    };
    let res = [];
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        res = response.data.list;
      }
    });
    return res;
  },

  /**
   * 获取利润中心列表（收货部门/工厂）
   * 1. 数据来源是业务单据，执行效率低。
   * 2. 使用场景：业务单据选择/显示收货部门
   *
   * @param companyCode          企业编码
   * @param customerXkUniqueCode 客户唯一编码
   * @param checkOpen            是否检查利润中心开启状态，默认不检查。如果检查，opts中必须传 customerCode。如果未开启直接返回空。
   * @param isTransform          是否转换为下拉选单数据
   * @param opts                 其他非必填参数
   *          poXkNo             订单号
   *          purchaseType       采购类型
   *          receiveCompanyCode 收货企业编码
   *          customerCode       客户企业编码
   * @returns
   */
  async getProfitCenter(
    companyCode: string,
    customerXkUniqueCode: string,
    checkOpen: boolean = false,
    isTransform: boolean = true,
    opts: any = {}
  ) {
    let res: any = [];
    if (Util.isEmpty(customerXkUniqueCode)) {
      return res;
    }
    if (checkOpen && opts.customerCode) {
      let isOpen = await this.checkOpenProfit(opts.customerCode);
      if (!isOpen) {
        return res;
      }
    }
    let postbody = {
      ...opts,
      companyCode,
      customerXkUniqueCode,
      apiPath: '/customerPurchase/getProfitCenter'
    };
    await Http.post('/api/cloudCenter?btnId=002', postbody).then(response => {
      if (response?.success) {
        let data = response.data;
        if (isTransform) {
          if (Array.isArray(data)) {
            data.forEach(val => {
              let profitCenterName = val.profitCenterName || '';
              res.push({
                id: val.profitCenterCode,
                text: '(' + val.profitCenterCode + ')' + profitCenterName,
                profitCenterName: profitCenterName
              });
            });
          }
        } else {
          res = response.data || [];
        }
      }
    });
    return res;
  },

  /**
   * 获取扩展字段
   * @param companyCode 企业编码
   * @param isCache     是否缓存
   * @param billType    单据类型，默认不传。po: 采购单头，poline: 采购单身，ro: 收货单头，roline: 收货单身，rto: 退货单头，rtoline: 退货单身，sto: 入库单头，stoline: 入库单身，req: 请购单头，reqLine: 请购单身
   * @returns
   */
  async getExtendFields(
    companyCode: string,
    isCache: boolean = false,
    billType: string = '',
    isPurchase: boolean = true
  ) {
    let postbody = {
      companyCode,
      billType: billType ? billType : undefined,
      apiPath: '/archives/barCode/compDynaFields'
    };
    let rs = {};
    let storageData;
    let cache;
    let itemKey;
    let sessionStorageKey = billType ? billType : '';
    if (isPurchase) {
      itemKey = sessionStorageKey + 'compDynaFields';
    } else {
      itemKey = 'cu' + sessionStorageKey + 'CompDynaFields';
    }

    if (isCache) {
      storageData = Storage.getItem(itemKey) || {};
      cache = storageData[companyCode];
    }

    if (cache) {
      return cache;
    } else {
      await Http.post('/api/cloudCenter', postbody).then(response => {
        if (response && response.success) {
          let fieldsShow = isPurchase
            ? response.data.fieldsShow
            : response.data.customerFieldsShow;
          if (typeof fieldsShow === 'string') {
            //有数据
            rs = Util.jsonDecode(fieldsShow);
            if (isCache) {
              storageData[companyCode] = rs;
              Storage.setItem(itemKey, storageData);
            }
          }
        }
      });
      return rs;
    }
  },

  /**
   * 获取客户列表
   * @param companyCode          企业编码
   * @param inviteStatusList     握手企业
   * @param customerStatus       客户企业状态
   * @returns
   */
  async getCustomerList(
    companyCode: string,
    inviteStatusList: any[] = [2],
    customerStatus: number = 1
  ) {
    if (!companyCode) {
      return [];
    }
    let res: any = [];
    let postbody = {
      companyCode,
      inviteStatusList,
      customerStatus,
      apiPath: '/archives/compCustomer/getSimpleListByCompCode'
    };
    await Http.post('/api/cloudCenter?btnId=002', postbody).then(response => {
      if (response?.success) {
        let data = response.data || [];
        if (Array.isArray(data)) {
          res = data.map(custom => {
            return {
              id: custom.xkUniqueCode,
              text: custom.innerCustomerCode
                ? custom.innerCustomerCode + '--' + custom.innerCustomerName
                : custom.innerCustomerName,
              customerCode: custom.customerCode
            };
          });
        } else {
          res = response.data || [];
        }
      }
    });
    return res;
  },

  /**
   * 获取企业枚举
   *
   * @param companyCode          企业编码
   * @param mainKey              枚举key
   * @param isTransform          是否转换为下拉选单数据
   * @param opts                 其他非必填参数
   *          pageNum            页码
   *          pageSize           每页几条
   *          extendValue        扩展字段值等
   * @returns
   */
  async getCompEnumList(
    companyCode,
    mainKey,
    isTransform: boolean = false,
    opts: any = {}
  ) {
    if (!companyCode) {
      return [];
    }
    let postbody = {
      companyCode,
      mainKey,
      orderProperty: 'subKey',
      ...opts,
      apiPath: '/archives/compEnum/list'
    };
    let arr: any[] = [];
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        arr = response.data || [];
        //转换格式
        if (isTransform) {
          arr = arr.map(item => {
            return {
              id: item.subKey,
              text: '(' + item.subKey + ')' + item.subValue,
              subValue: item.subValue
            };
          });
        }
      }
    });
    return arr;
  },

  /**
   * 获取客户默认条码规则
   * @param companyCode 企业编码
   * @param xkUniqueCode 客户平台编码
   * @param barcodeRulesType 条码类型 1:送货条码 2:生产条码
   */
  async getCustDefaultBarcodeRule(
    companyCode: string,
    xkUniqueCode: string,
    barcodeRulesType
  ) {
    const postbody = {
      companyCode,
      xkUniqueCode,
      apiPath: '/archives/compCustomer/getDefaultRule'
    };
    let res;
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success && Array.isArray(response.data)) {
        res = response.data.filter(
          item => item.barcodeRulesType === barcodeRulesType
        )[0];
      }
    });
    return res;
  },

  /**
   * 获取客户已选中的条码规则
   * @param xkUniqueCode
   * @param barcodeRulesType 条码规则类型 1.送货单；2.采购单
   * @returns
   */
  async getCustomerRuleList(xkUniqueCode, barcodeRulesType: number = 1) {
    let postbody = {
      companyCode: User.getDefaultCompanyCode(),
      xkUniqueCode: xkUniqueCode,
      apiPath: '/archives/compCustomer/findRuleDetailByXkUniqueCode'
    };
    let res: any[] = [];
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        res = response.data || [];
      }
    });

    res = res.filter(item => item.barcodeRulesType === barcodeRulesType);

    //如果采购方没有给此供应商设置规则，取采购方默认规则
    if (Util.isEmpty(res)) {
      let defaultRule = await this.getCustDefaultBarcodeRule(
        User.getDefaultCompanyCode(),
        xkUniqueCode,
        barcodeRulesType
      );
      if (defaultRule) {
        res.push(defaultRule);
        return res;
      }
    }

    return res;
  },

  /**
   * 获取自定义分类数据
   *
   * @param companyCode
   * @param categoryTypeList
   * @returns
   */
  async getCustomizeCate(companyCode: string, categoryTypeList, params?) {
    let postbody = {
      apiPath: '/archives/customizeCategory/getSimpleList',
      companyCode,
      categoryTypeList,
      ...params
    };
    let rs = [];
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        rs = response.data || [];
      }
    });
    return rs;
  },

  // 获取分类列表（物料分类|供应商分类）
  async getCustomizeCategory(companyCode, categoryTypeList) {
    let arr: any[] = [];
    let postbody = {
      companyCode,
      categoryTypeList,
      apiPath: '/archives/customizeCategory/getList'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        if (Array.isArray(response.data)) {
          arr = response.data.map(item => {
            return {
              id: item.categoryCode,
              text: '(' + item.categoryCode + ')' + item.categoryName,
              categoryName: item.categoryName,
              categoryType: item.categoryType
            };
          });
        }
      }
    });
    return arr;
  },

  // 获取集团子公司
  async getCompRelationList(
    companyCode: string,
    relationFlag = 2,
    filterUserAuthFlag?,
    erpOrgCode?
  ) {
    let arr: any[] = [];
    let postbody = {
      companyCode,
      relationFlag,
      filterUserAuthFlag,
      erpOrgCode,
      apiPath: '/archives/compRelation/list'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        response.data.forEach(custom => {
          arr.push({
            id: custom.rCompanyCode,
            text: custom.rCompanyName,
            isDataCentre: custom.isDataCentre
          });
        });
      }
    });
    return arr;
  },

  //获取收货地点列表
  async getDeliveryAddressList(companyCode: string) {
    let arr: any[] = [];
    let postbody = {
      companyCode,
      apiPath: '/archives/inner/delivery/address/getList'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        response.data.forEach(custom => {
          let address =
            (custom.countryName || '') +
            ' ' +
            (custom.provinceName || '') +
            (custom.cityName || '') +
            (custom.districtName || '') +
            ' ' +
            custom.detailedAddress;
          arr.push({
            id: custom.deliveryPlaceCode,
            text: custom.deliveryPlaceName,
            detailedAddress: address,
            contactPerson: custom.contactPerson,
            contactWay: custom.contactWay
          });
        });
      }
    });
    return arr;
  },

  /**
   * 通过companyCode获取企业信息
   * @param companyCode    企业编码
   * @param vendorCode     供应商企业编码，涉及到供应商名称查看权限的地方，需传此编码
   * @returns
   */
  async getCompanyDetailByCode(
    companyCode: string,
    type: string = 'simple',
    vendorCode: string = ''
  ) {
    let res: any = {};
    if (!companyCode) {
      return res;
    }
    let apiPath =
      type === 'simple'
        ? '/archives/company/getSimpleDetail'
        : '/archives/company/getDetailByCode';
    let postbody: any = {
      companyCode,
      apiPath
    };
    if (vendorCode) {
      postbody.apiPath = '/archives/company/queryVendorCompanyInfo';
      postbody.vendorCode = vendorCode;
    }
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        res = response.data;
      }
    });
    return res;
  },

  //潜在供应商 审核供应商信息
  sourcingAuditVendor(
    companyCode: string,
    xkUniqueCode: string,
    cb: Function = () => {},
    dispatch: Function
  ) {
    let ok = () => {
      let config = {
        companyCode,
        xkUniqueCode,
        inviteStatus: 2,
        apiPath: '/archives/compPotVendor/audit',
        successMsg: '操作成功'
      };
      BaseService.save(config, cb, dispatch);
    };
    Modal.showConfirm('您是否确认此操作？', ok, dispatch);
  },

  //潜在供应商 审核供应商信息
  sourcingReturnVendor(
    companyCode: string,
    xkUniqueCode: string,
    cb: Function = () => {},
    dispatch: Function
  ) {
    let ok = async (reason?) => {
      let config = {
        companyCode,
        xkUniqueCode,
        inviteStatus: 5,
        returnReason: reason,
        apiPath: '/archives/compPotVendor/audit',
        successMsg: '退回成功'
      };
      let rs;
      await BaseService.save(config, cb, dispatch).then(response => {
        rs = response;
      });
      return rs;
    };
    Modal.showReject('确认退回', ok, '退回', 'showReject', '', dispatch);
  },

  /**
   * 获取单别列表
   *
   * 用于工作台待处理，待跟进，待审批列表中高级搜索中业务类型
   *
   * @param tabType 1.待处理 2.待跟进 3.待审批
   */
  async getBillTypeList(tabType: number) {
    let arr: any[] = [];
    await Http.post('/api/cloudCenter', {
      apiPath: '/oss/waitBillType',
      tabType
    }).then(response => {
      if (response.success) {
        response.data?.forEach(item => {
          arr.push({
            id: item.subKey,
            text: item.subValue
          });
        });
      }
    });
    return arr;
  },

  /**
   * 获取ERP单别列表
   * @param companyCode    企业编码
   * @param billType       单据类型 1采购,2收货,3入库,4退货,5发票单,6销售单,7销售出货,8销售出库,9销售退货,10销售发票,11销售对账,12核价单,13请购单,14对账单,15付款单
   * @param [purchaseType] 采购类型 string[]
   * @returns              返回列表原始数据
   */
  async getFormTypeData(companyCode, billType, purchaseType) {
    let postbody = {
      companyCode,
      billType,
      purchaseType,
      apiPath: '/archives/formType/getList'
    };
    let data = [];
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response?.success) {
        data = response.data || [];
      }
    });
    return data;
  },

  /**
   * 获取币别列表
   *
   * @param companyCode 企业编码
   * @param [status] 状态
   * @param isSimple 是否返回下拉选单列表
   * @param erpOnly  仅返回ERP数据
   *
   * @returns 币别列表
   */
  async getCurrencyList(
    companyCode: string,
    status: number = 1,
    isSimple: boolean = true,
    erpOnly: boolean = false
  ) {
    if (isEmpty(companyCode) || companyCode === '0') {
      return [];
    }
    let postbody = {
      companyCode,
      status,
      apiPath: '/archives/compCurrency/getListByCompCode'
    };
    let res: any[] = [];
    await Http.post('/api/cloudCenter', postbody).then(async response => {
      if (response.success) {
        let data = response.data || [];
        if (isSimple) {
          res = data.map(item => {
            return {
              id: item.currencyCode,
              text: '(' + item.currencyCode + ') ' + item.currencyName,
              name: item.currencyName,
              currencyName: item.currencyName
            };
          });
        } else {
          res = data;
        }

        if (isEmpty(data) && isSimple && !erpOnly) {
          //无数据时，取枚举配置
          await EnumService.getList('B2b_Platform_Currency_Code').then(arr => {
            res = arr.map(item => {
              return {
                id: item.subKey,
                text: '(' + item.subKey + ') ' + item.subValue,
                name: item.subValue,
                currencyName: item.subValue
              };
            });
          });
        }
      }
    });
    return res;
  },
  /**
   * 获取仓库列表。采购方基本资料-仓库别。
   *
   * @param companyCode
   * @param profitCenterCode            利润中心编码，多利润中用逗号分隔
   * @param bondedWay                   保税方式，0:保税，1:非保税，2:不限
   * @param unlimitedFlag               保税方式 = 保税 或 非保税，是否要包含不限
   * @param operateType                 操作类型，1.送货转收货入库. 按工厂匹配不到对应仓库，返回全部工厂为空的仓库列表
   * @param isTransform                 是否转换为下拉选单数据
   * @param isSimple                    是否精简版
   * @param status                      Integer[0：无效 1：有效]，默认有效
   * @returns 仓库列表
   */
  async getStroeList(
    companyCode,
    profitCenterCode: string,
    bondedWay: string = '2',
    operateType: number | undefined = undefined,
    isTransform: boolean = false,
    isSimple: boolean = false,
    unlimitedFlag: number = 0,
    status?
  ) {
    let res: any[] = [];
    let postbody = {
      companyCode,
      profitCenterCode: profitCenterCode ? profitCenterCode : undefined,
      bondedWay: ['0', '1'].includes(bondedWay) ? bondedWay : undefined, //（2.不限时，传undefined）
      unlimitedFlag: ['0', '1'].includes(bondedWay) ? unlimitedFlag : undefined, //（bondedWay = 不限时，不传此参数）
      operateType: operateType ? operateType : undefined,
      status: status ? status : undefined,
      apiPath:
        isSimple === true
          ? '/archives/store/getSimpleList'
          : '/archives/store/getList'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data;
        if (isTransform) {
          if (Array.isArray(data)) {
            res = data.map(item => {
              return {
                id: item.storeCode,
                storeName: item.storeName,
                text: '(' + item.storeCode + ')' + item.storeName
              };
            });
          }
        } else {
          res = data || [];
        }
      }
    });
    return res;
  },
  /**
   * 获取库位列表（分页）
   *
   * @param companyCode
   * @param opts                 其他非必填参数
   *          pageNum            页码，跳页时必填，覆盖默认值
   *          pageSize           每页几条
   *          searchKey          搜索库位名称和编码
   *          status             Integer[0：无效 1：有效]，默认有效
   *          storeCode          仓库编码，根据仓库过滤库位
   * @returns object
   */
  async getStoreLocationPageList(companyCode, opts: any = {}) {
    let res: any = {};
    let postbody = {
      companyCode,
      pageNum: 1,
      pageSize: 10,
      ...opts,
      apiPath: '/archives/storeLocation/getPageList'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        res = response.data || {};
      }
    });
    return res;
  }
};

export default CompanyService;
